// A labelled number input for the calculators.
import { useId } from "react";

export function NumberField({ label, hint, value, onChange, min = 0, step = 1, suffix }: { label: string; hint?: string; value: number; onChange: (n: number) => void; min?: number; step?: number; suffix?: string }) {
  const id = useId();
  return (
    <div>
      <label htmlFor={id} className="block text-[14px] font-semibold">
        {label}
      </label>
      {hint ? <p className="text-[12.5px] text-ink3">{hint}</p> : null}
      <div className="relative mt-1.5">
        <input id={id} type="number" inputMode="decimal" min={min} step={step} value={Number.isFinite(value) ? value : ""} onChange={(e) => onChange(Number(e.target.value))} className="field pe-16" />
        {suffix ? <span className="pointer-events-none absolute end-3.5 top-1/2 -translate-y-1/2 font-mono text-[11.5px] text-ink3">{suffix}</span> : null}
      </div>
    </div>
  );
}

export function Big({ label, value, tone = "text-ink" }: { label: string; value: string; tone?: string }) {
  return (
    <div>
      <p className="kicker">{label}</p>
      <p className={`mt-1 font-display text-4xl font-extrabold tracking-tight ${tone}`}>{value}</p>
    </div>
  );
}
